import React from "react";

export default function WelcomeCard({ name = "back" }) {
    const today = new Date();
    const formatted = today.toLocaleDateString("en-US", {
        weekday: "long",
        month: "long",
        day: "numeric"
    });

    return (
        <div className="bg-[#1E1F25] border border-[#2A2B32] rounded-xl px-6 py-5 shadow-lg mb-6">
            <div className="flex flex-col gap-1">

                {/* Date */}
                <div className="text-xs text-gray-500">
                    {formatted}
                </div>

                {/* Welcome */}
                <div className="text-sm text-gray-400">
                    Welcome {name} 👋
                </div>

                {/* Main Line */}
                <div className="text-xl md:text-2xl font-semibold text-gray-100 leading-snug">
                    Learn smarter. <span className="text-indigo-400">Stay consistent.</span>
                </div>

                {/* Subline */}
                <div className="text-sm text-gray-400">
                    Your daily learning system.
                </div>
            </div>
        </div>
    );
}
